import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

export class ComponentPageStateConfigManager {
  static getConfigForComponent(component) {
    return ComponentPageStateConfigManager.componentConfigurationWeakMap.get(component);
  }
  static setConfigForComponent(component, config) {
    ComponentPageStateConfigManager.componentConfigurationWeakMap.set(component, config);
  }
}
/*
Rather than mutating the object, this stores a configuration object with a WeakKey to the
object. When it is garbage collected, the configuration will be collected as well.
*/
_defineProperty(ComponentPageStateConfigManager, "componentConfigurationWeakMap", new WeakMap());
//# sourceMappingURL=ComponentPageStateConfigManager.js.map
